import "./sfaLandingPage.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import PopUpModal from "../../src/Home/Modal/PopUpModal";
import { useLocation } from "react-router-dom";

import Footer from "../Home/Components/Footer";
import Header from "../header/Header";
import { useEffect } from "react";
import SfaHero from "./sections/sfaHero";
import SfaAbout from "./sections/sfaAbout";
import SfaMobileExperience from "./sections/sfaMobileExperience";
import SfaComparison from "./sections/sfaComparison";
import SfaTrustedBrands from "./sections/sfaTrustedBrands";
import SfaIndustriesServed from "./sections/sfaIndustriesServed";
import SfaFaq from "./sections/sfaFaq";
import SfaKeyFeatures from "./sections/sfaKeyFeatures";

const SfaLandingPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
      delay: 0,
    });

    const timer = setTimeout(() => {
      AOS.refresh();
    }, 300);

    return () => clearTimeout(timer);
  }, []);
  const Location = useLocation();
  const isSfaPage = Location.pathname === "/sfa-implement";
  return (
    <>
      <Helmet>
        <title>Sales Force Automation | Field Sales Management Software</title>
        <meta
          name="description"
          content="Empower your sales team with TechCognics Sales Force Automation. Manage attendance, beat planning, outlet visits, field activity, orders, GPS tracking and sales performance from one connected platform."
        />
        <meta
          name="keywords"
          content="Sales Force Automation, SFA software, sales force automation software, field sales management software, sales team tracking software, beat planning software, outlet management software, field sales tracking, sales automation"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          property="og:title"
          content="Sales Force Automation | TechCognics"
        />
        <meta
          property="og:description"
          content="Plan beats, manage outlets, track field activity, capture orders and gain real-time visibility into your sales force with TechCognics SFA."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.techcognics.com/sfa-implement"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sales Force Automation | TechCognics"
        />
        <meta
          name="twitter:description"
          content="Manage field sales teams, attendance, beats, outlets, visits, orders and sales activity with TechCognics SFA."
        />
      </Helmet>
      <PopUpModal />
      <Header />
      <main id="main-content" role="main">
        <SfaHero />
        <SfaAbout />
        <SfaMobileExperience />
        <SfaKeyFeatures/>
        <SfaTrustedBrands/>
        <SfaComparison/>
        <SfaIndustriesServed/>
        <SfaFaq/>
      </main>
      <Footer />
    </>
  );
};

export default SfaLandingPage;